export const LogoMark = ({ className = "h-8 w-8", variant = "mark" }) => (
  <img
    src={variant === "leaf" ? "/brand/leaf.png" : "/brand/mark.png"}
    alt=""
    aria-hidden="true"
    className={`${className} select-none object-contain`}
    draggable={false}
  />
);

/** Brand lockup as in the reference site: leaf mark + spaced wordmark + green subline. */
export const Logo = ({ light = false, className = "" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <img
      src="/brand/mark.png"
      alt=""
      aria-hidden="true"
      className="h-10 w-11 select-none object-contain md:h-11 md:w-12"
      draggable={false}
    />
    <span className="font-display leading-[1.05]">
      <span
        className={`block text-[15px] font-semibold uppercase tracking-[0.2em] md:text-base ${light ? "text-white" : "text-ink"}`}
      >
        Veridian
      </span>
      <span
        className={`mt-0.5 block text-[9.5px] font-medium uppercase tracking-[0.22em] md:text-[10px] ${light ? "text-mintlight" : "text-pine"}`}
      >
        Education Foundation
      </span>
    </span>
  </span>
);
